'use strict';
import './index.scss';

import app from '../../ngmodule';
import { ControllerBase } from '../../control-base';

export class ActionColumnController extends ControllerBase {
    public cssClass: string | undefined;

    static $inject = ['$element'];
    constructor(protected $element: ng.IRootElementService) {
        super();
    }    

    protected valuesFromHtml() : void {
        if (this.cssClass == undefined) {
            this.cssClass = this.valueFromHtml("class", '', this.$element);
        }
    }

    $onInit(): void {
        this.valuesFromHtml();
    }    
}

app.component('vmActionColumn', {
    template: require('./template.html').default,
    transclude: true,
    controller: ActionColumnController
});